module.exports = __webpack_public_path__ + "static/img/Aries.fe9a12e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/zodiac_image/Aries.svg
// module id = 1395
// module chunks = 0